import Component from '../app/component'
import gsap from 'gsap'

export default class extends Component {
  constructor(el) {
    super(el)
    this.data = {
      display: false
    }
    if (sessionStorage.getItem('homeloader') === '1') {
      sessionStorage.setItem('homeloader', '0')
      this.display = true
    }
  }

  init() {
    if (this.display) {
      this.videoSet()
      this.el.classList.add('homeloader--active')
      document.body.classList.add('layout-unscrollable')
      this.refs.video.addEventListener('ended', () => {
        this.close()
      })
    } else {
      this.el.remove()
    }
  }

  videoSet() {
    const hours = new Date().getHours()
    if (hours >= 5 && hours < 9) {
      // test portrait
      if (window.screen.height > window.screen.width) {
        this.refs.video.src = '/assets/mp4/homeintro1-portrait.mp4'
      }
      else {
        this.refs.video.src = '/assets/mp4/homeintro1.mp4'
      }
    } else if(hours >= 9 && hours < 17) {
      if (window.screen.height > window.screen.width) {
        console.log('portrait')
        this.refs.video.src = '/assets/mp4/homeintro2-portrait.mp4'
      }
      else {
        this.refs.video.src = '/assets/mp4/homeintro2.mp4'
      }
    } else if(hours >= 17 && hours < 20) {
      if (window.screen.height > window.screen.width) {
        this.refs.video.src = '/assets/mp4/homeintro3-portrait.mp4'
      }
      else {
        this.refs.video.src = '/assets/mp4/homeintro3.mp4'
      }
    } else {
      if (window.screen.height > window.screen.width) {
        this.refs.video.src = '/assets/mp4/homeintro4-portrait.mp4'
      }
      else {
        this.refs.video.src = '/assets/mp4/homeintro4.mp4'
      }
    }
  }

  close() {
    gsap.to(
      this.el,
      {
        opacity: 0,
        duration: 1.5,
        ease: 'power2.inOut',
        onComplete: () => {
          document.body.classList.remove('layout-unscrollable')
          this.el.remove()
        }
      }
    )
  }
}
